<template>
  <v-card flat tile class="fid-card">
    <v-toolbar>
      <v-toolbar-title v-if="contentHeading">
        <div class="title">{{ contentHeading }}</div>
      </v-toolbar-title>
      <v-spacer>      </v-spacer>
      <hide-detail 
        prop-name="hideContent"
        :tooltip="contentHeading"
        left
        :hide="hideContent"
        @hide="hide"
      ></hide-detail> 
    </v-toolbar>
    <v-card-text v-if="!hideContent">
      <span v-if="items && items.length">
        <detail-table  
          v-for="(item,index) in items" :key="index" 
          :item-reason="itemReason"
          :source="getSource(item,itemName)" 
          :item-type="itemType" 
          :image-column="imageColumn">
        </detail-table>
      </span>
      <div v-else>No information</div>
    </v-card-text>
  </v-card>
</template>
<script>
import Detailtable from '@/components/Detailtable'
import Hidedetail from '@/components/Hidedetail'
export default {
  props: {
    items: Array,
    itemName: String,
    itemType: String,
    imageColumn: Boolean,
    contentHeading: String,
    itemReason: Object
  },
  data: () => ({
    hideContent: false
  }),
  methods: {
    hide (pack) {
      this[pack.propName] = pack.hide
    },
    getSource (item, itemName) {
      const result = item && (itemName ? item[itemName] : item)
      return result
    }
  },
  components: {
    'detail-table': Detailtable,
    'hide-detail': Hidedetail
  },
  name: 'Contentdetail'
}
</script>
